module.exports = __webpack_public_path__ + "static/media/dodging_mask.04484492.jpg";